module.exports = require("/tmp/build_3676ea55/src/lib/gatsby/gatsby-browser.tsx");